<template>
  <div>
    <el-popover
    placement="top-start"
    title="设备信息"
    width="200"
    trigger="hover">
    <div>
      <div v-if="(message.state == null || message.state == '') && (message.devId == null || message.devId == '')">{{ '设备名：'+message.devName }}</div>
      <div v-if="message.devId">{{ '设备ID：'+message.devId }}</div>
      <div v-if="message.state">状态: <span :style="{color:message.color}">{{ message.txt =='在线' && !!!message.devId ?'未安装':message.txt }}</span> </div>
    </div>
    <div slot="reference">
    <svg width="30px" height="31px" viewBox="0 0 30 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>编组 6</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="项目基本信息备份" transform="translate(-571.000000, -602.000000)" :fill="backColor" :stroke="borderColor">
                <g id="编组-6" transform="translate(571.000000, 602.000000)">
                    <path d="M17.1144226,4.5 C17.5230009,4.5 17.9138991,4.66666826 18.1967754,4.96148548 L18.1967754,4.96148548 L19.0823528,5.88444526 C19.3503541,6.1637596 19.5,6.53586649 19.5,6.92295978 L19.5,6.92295978 L19.5,12.9774558 C19.5,13.315208 19.3860112,13.6430755 19.1764862,13.9079827 L19.1764862,13.9079827 L15.2039683,18.9305269 C14.9194778,19.2902146 14.4860779,19.5 14.0274821,19.5 L14.0274821,19.5 L9.86657112,19.5 C9.40174289,19.5 8.96317783,19.2845022 8.67915559,18.9165393 L8.67915559,18.9165393 L4.81258447,13.9072327 C4.60992578,13.6446797 4.5,13.3223627 4.5,12.9906933 L4.5,12.9906933 L4.5,6.89180242 C4.5,6.49499466 4.65723054,6.11435366 4.93726643,5.83321971 L4.93726643,5.83321971 L5.82558561,4.94141729 C6.10705705,4.65884216 6.48947727,4.5 6.88831919,4.5 L6.88831919,4.5 Z" id="矩形备份-17"></path>
                    <circle id="椭圆形备份-3" cx="12" cy="11" r="3.5"></circle>
                    <path d="M4.5,7.5 L4.5,11.5 L1.5,11.5 C1.22385763,11.5 0.973857625,11.3880712 0.792893219,11.2071068 C0.611928813,11.0261424 0.5,10.7761424 0.5,10.5 L0.5,10.5 L0.5,8.5 C0.5,8.22385763 0.611928813,7.97385763 0.792893219,7.79289322 C0.973857625,7.61192881 1.22385763,7.5 1.5,7.5 L1.5,7.5 L4.5,7.5 Z" id="矩形备份-18"></path>
                    <rect id="矩形备份-20" x="19.5" y="7.5" width="4" height="4"></rect>
                    <path d="M29.5,6.5 L29.5,13.5 C29.5,13.7761424 29.3880712,14.0261424 29.2071068,14.2071068 C29.0261424,14.3880712 28.7761424,14.5 28.5,14.5 L28.5,14.5 L24.5,14.5 C24.2238576,14.5 23.9738576,14.3880712 23.7928932,14.2071068 C23.6119288,14.0261424 23.5,13.7761424 23.5,13.5 L23.5,13.5 L23.5,6.5 L29.5,6.5 Z" id="矩形备份-21"></path>
                    <rect id="矩形备份-22" x="10.5" y="19.5" width="3" height="4"></rect>
                    <path d="M12.1768368,0.5 C12.6354137,0.5 13.068798,0.709768209 13.3532896,1.069431 L13.3532896,1.069431 L13.8431195,1.68868844 C14.0526654,1.95360256 14.1666667,2.28148684 14.1666667,2.61925744 L14.1666667,2.61925744 L14.1666667,4.5 L9.26190476,4.5 L9.26190476,2.61270419 C9.26190476,2.27346431 9.37689845,1.94424237 9.58811508,1.67877819 L9.58811508,1.67877819 L10.0756133,1.06607399 C10.3601953,0.708401689 10.7923292,0.5 11.249403,0.5 L11.249403,0.5 Z" id="矩形备份-24"></path>
                    <rect id="矩形备份-25" x="8.5" y="23.5" width="7" height="7" rx="1.5"></rect>
                    <path d="M26.5,2.5 C27.3284271,2.5 28.0784271,2.83578644 28.6213203,3.37867966 C29.1642136,3.92157288 29.5,4.67157288 29.5,5.5 L29.5,5.5 L29.5,6.5 L23.5,6.5 L23.5,5.5 C23.5,4.67157288 23.8357864,3.92157288 24.3786797,3.37867966 C24.9215729,2.83578644 25.6715729,2.5 26.5,2.5 Z" id="矩形备份-26"></path>
                </g>
            </g>
        </g>
    </svg>
    </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  inject:['getNode'],
  data() {
    return {
      borderColor: '#979797',          // 边框颜色
      backColor: 'transparent',        // 背景颜色
      openPolice: false,               // 开启报警
      openOnLine: false,               // 是否在线
      openOffLine:false,               // 是否离线
      polineColor: 'red',              // 报警颜色
      onLineColor: 'green',            // 在线颜色
      offLineColor: '#979797',         // 离线颜色
      interArr:[],
      defaultColor:'#979797',
      message:{
        devName:'工业燃气报警',
        state:false,
        color:'#979797',
        txt:'',
        devId:''
      },
    };
  },
  mounted(){
    const node = this.getNode();
    console.log('node1111',node.getData())
    this.message = node.getData().devName
    node.on('change:data',(res)=>{
      console.log("svg",res)
      let {current}  = res;
      if(current.svgData.borderColor != '')
        this.borderColor = current.svgData.borderColor;
      if(current.svgData.backColor != '')
        this.backColor = current.svgData.backColor;
      if(current.svgData.openPolice){
        let ms = 0;
        this.borderColor = current.svgData.polineColor||this.polineColor;
        let interCode = setInterval(()=>{
          if(ms % 2 != 0){
            this.borderColor = current.svgData.polineColor||this.polineColor;
          }else{
            this.borderColor = this.onLineColor;
          }
          ms++;
        },1000)
        this.interArr.push(interCode);
      }
      if(current.svgData.openOnLine){
        this.borderColor = this.onLineColor;
        // this.borderColor = this.defaultColor;
      }
      if(current.svgData.openOffLine){
        this.borderColor = this.defaultColor;
        // this.borderColor = current.svgData.offLineColor;
      }

       // 设置状态   openPolice: false, // 开启报警 openOnLine: false, // 是否在线openOffLine:false, // 是否离线
       this.message = this.message || {devName:current.svgData.devName || '工业燃气报警'}
        this.message.devId = current.svgData.devId
     
      this.message.state = true;
      this.message.txt =  current.svgData.openPolice?'报警': current.svgData.openOnLine?'在线':'离线';
      this.message.color =  current.svgData.openPolice?current.svgData.polineColor|| current.svgData.polineColor:this.openOnLine?current.svgData.onLineColor || this.onLineColor:current.svgData.onLineColor || this.onLineColor;
    
    })
  },
  beforeDestroy(){
    this.interArr.forEach(item=>{
      clearTimeout(item);
    })
  }
}
</script>

<style>
</style>